import React, { useEffect, useState } from "react";
 
import "./Image.css";

export const Image = () => {

    const [image_result, setImage] = useState();

    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        getImage();
    }, [])

    const getImage = async () => {

        setLoading(true)

        const url = "https://landschaftenmachenv2.me/stylegan/get_random_generated_img";

        fetch(url, {
            headers: new Headers({
                'Authorization': 'Basic ' + btoa(process.env.REACT_APP_U + ":" + process.env.REACT_APP_P),
            })
        })
            .then(r => r.arrayBuffer())
            .then(buffer => { 
                const blob = new Blob([buffer]);
                const url = URL.createObjectURL(blob);

                //console.log(url);
                setImage(url);
                setLoading(false);
            })
    
    }

    return (
        <div>
            <img className="image" src={image_result} />

            <div style={{ textAlign: "center" }}>
                <button className="button" onClick={() => getImage()} disabled={isLoading}>
                {isLoading && (
                    <i
                    className="fa fa-refresh fa-spin"
                    style={{ marginRight: "5px" }}
                    />
                )}
                {isLoading && <span>Landschaft wird generiert</span>}
                {!isLoading && <span>Landschaft generieren</span>}
                </button>
            </div>

        </div>
    );
};